'use strict';

import { cn_building } from '../../model/cn_building';
import { cn_storey } from '../../model/cn_storey';
import { cn_zone, ZONE_EXTERIOR_LABEL } from '../../model/cn_zone';
import {
    cn_nomenclature,
    find_zone,
    NOMENCLATURE_COLUMNS_ID_FACING,
    NOMENCLATURE_COLUMNS_ID_FACING_SURFACE,
    NOMENCLATURE_LABEL_FACING_NONE,
    push_cn_nomenclatures_zones
} from '../cn_nomenclature';
import { extension_instance } from '../../extension/cn_extension';

//***********************************************************************************
//***********************************************************************************
//**** Build nomenclatures
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
/**
 * Buils facing nomenclatures for the building
 * @param {cn_building} building
 * @returns {cn_nomenclature[]}
 */
export function cn_nomenclature_moldings(building) {

    building.update_roofs();
    building.compute_altitudes();

    const output = [];
    output.push(new cn_nomenclature('ID').withVirtual(true));
    output.push(new cn_nomenclature('ASSOCIATED_IDS').withVirtual(true));
    output.push(new cn_nomenclature('Niveau'));
    output.push(new cn_nomenclature('Index niveau').withVisibility(false));
    push_cn_nomenclatures_zones(output, true);
    output.push(new cn_nomenclature('Pièce'));
    output.push(new cn_nomenclature('Usage').withVisibility(false));
    output.push(new cn_nomenclature('Type'));
    output.push(new cn_nomenclature('Revêtement'));
    output.push(new cn_nomenclature('Linéaire').withNumberDefinition('m', 2));

    const zones = building.zones;
    [building.exterior, ...building.storeys].forEach((storey) => {
        populate_nomenclature_moldings(building, storey, output, zones);
    });

    return output;
}

//***********************************************************************************
/**
 *
 * @param {cn_building} building
 * @param {cn_storey} storey
 * @param {cn_nomenclature[]} output
 * @param {{[property: string]: cn_zone[]}} zones
 */
function populate_nomenclature_moldings(building, storey, output, zones) {
    storey.scene.storey = storey;
    storey.scene.update_deep();

    //*** We compute the storey volume */
    storey.build_facing_volume();

    //*** Loop on storeys */
    storey.scene.spaces.length && storey.scene.spaces.forEach(space => {
        const zones_names = [];
        extension_instance.zone.get_zones_tools().forEach(tool_zone => {
            const zone_name = (storey.exterior) ? '-' : (space.outside) ? ZONE_EXTERIOR_LABEL : find_zone(zones[tool_zone.property], space.ID, storey.ID);
            zones_names.push(zone_name);
        });
        const space_name = space.get_name(storey);
        const space_usage = space.space_type ? space.space_type.space_usage : '';

        //*** Floor spacing */
        const molding_type_datas = [];

        space.space_segments.forEach(sslist => sslist.forEach(ss => {
            ss.moldings.forEach((molding, i) => {
                let molding_facing = ss.molding_facings[i];
                let mtd = molding_type_datas.find(m => m.molding == molding && m.facing == molding_facing);
                if (!mtd) {
                    mtd = { molding: molding, facing: molding_facing, lineic: 0, ID: cn_building.create_unique_id(ss, storey, molding, molding_facing), associated_ids: [] };
                    molding_type_datas.push(mtd);
                }
                mtd.lineic += ss.get_molding_metrics(i, storey);
                mtd.associated_ids.push(cn_building.create_unique_id(ss, storey, i));
            });
        }));
        molding_type_datas.forEach(mtd => {

            let k = 0;
            output[k].values.push(mtd.ID);
            k++
            output[k].values.push(mtd.associated_ids);
            k++
            output[k].values.push(storey.exterior ? 'Extérieur' : storey.get_storey_name());
            k++
            output[k].values.push(storey.get_storey_index_in_building());
            k++
            zones_names.forEach(zone_name => {
                output[k].values.push(zone_name);
                k++;
            });
            output[k].values.push(space_name);
            k++
            output[k].values.push(space_usage);
            k++
            output[k].values.push(mtd.molding.get_label());
            k++
            output[k].values.push((mtd.facing) ? mtd.facing.name : 'Aucun');
            k++
            output[k].values.push(mtd.lineic);
            k++
        });

    });
}

